module.exports = __webpack_public_path__ + "static/media/aside.75a1b051.jpg";